// @flow

import Dispatcher from 'dispatcher';
import ApiClient from 'utils/ApiClient';
import {
  DASHBOARD_DATA_CHANGE,
  DASHBOARD_LOADING,
  DASHBOARD_ERROR,
  DASHBOARD_UPDATE_QUERY_STRING,
  DASHBOARD_UPDATE_STATUS,
  DASHBOARD_UPDATE_APPLICATION,
  DASHBOARD_UPDATE_ACTIVE_STEP
} from 'modules/dashboards/api/action_types/DashboardActionTypes';
import HomeApplication from 'models/HomeApplication';

class DashboardAction {
  getApplicationsDashboard(filters: any): Promise<any> {
    return ApiClient.get({
      path: '/home_applications.json',
      data: filters,
      beforeSend: () => {
        if (!Dispatcher.isDispatching()) {
          Dispatcher.dispatch({
            type: DASHBOARD_LOADING,
            isLoading: true
          });
        }
      },
      success: ({ home_applications, meta }) => {
        if (!Dispatcher.isDispatching()) {
          Dispatcher.dispatch({
            type: DASHBOARD_DATA_CHANGE,
            applications: home_applications.map(
              home_application => new HomeApplication(home_application)
            ),
            meta,
            isLoading: false
          });
        }
      },
      error: error => {
        if (!Dispatcher.isDispatching()) {
          Dispatcher.dispatch({
            type: DASHBOARD_ERROR,
            isLoading: false,
            error: error
          });
        }
      }
    });
  }

  sendRequestUpdateFicoScore(
    home_application_id: string,
    success?: () => void,
    error?: () => void
  ): Promise<any> {
    return ApiClient.post({
      path: `/home_applications/${home_application_id}/request_update_fico_score`,
      success: response => {
        if (success) success();
      },
      error
    });
  }

  sendRequestUpdateHome(
    homeApplicationId: string,
    homeId: string,
    success?: () => void,
    error?: () => void
  ): Promise<any> {
    return ApiClient.put({
      path: `/home_applications/${homeApplicationId}/update_home`,
      data: { home_id: homeId },
      success: response => {
        if (success) success();
      },
      error
    });
  }

  updateQueryString(queryString: string) {
    Dispatcher.dispatch({
      type: DASHBOARD_UPDATE_QUERY_STRING,
      queryString
    });
  }

  updateStatus(queryStatus: string) {
    Dispatcher.dispatch({
      type: DASHBOARD_UPDATE_STATUS,
      status: queryStatus
    });
  }

  updateApplicationProperty(applicationId, property, value) {
    Dispatcher.dispatch({
      type: DASHBOARD_UPDATE_APPLICATION,
      applicationId: applicationId,
      value: value,
      property: property
    });
  }

  updateActiveStep(activeStep: string) {
    Dispatcher.dispatch({
      type: DASHBOARD_UPDATE_ACTIVE_STEP,
      activeStep
    });
  }

  getRentsByUser(userId: string): Promise<any> {
    return ApiClient.get({
      path: `/users/${userId}/rents`
    });
  }
}

export default new DashboardAction();
